import React from 'react';
import ReactDOM from 'react-dom/client';
import './assets/fonts/types.css';
import './assets/styles/swiper-fix.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

window.localStorage.removeItem('hsencriptedkey');

const root = ReactDOM.createRoot(
	document.getElementById('root') as HTMLElement
);
root.render(
	<React.StrictMode>
		<App />
	</React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
